import { render } from "./MinerCard.vue?vue&type=template&id=509c1cca"
import script from "./MinerCard.vue?vue&type=script&lang=js"
export * from "./MinerCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__